import { Divider, Card } from "@mui/material";
import { getEvidenceType } from "../../../common/EntitiesManagement";
import localize from "../../../common/localize";
import ActionButtons from "../../../components/common/ActionButtons";
import { Visibility } from "@mui/icons-material";

export default function ReviewCard({ review, showEditNote }) {
  return (
    <Card
      variant="outlined"
      className="flex-col w-full rounded-xl items-center content-center justify-center p-5"
    >
      <div
        className="mb-2"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <label className="text-xs">
          <b>{review.Title}</b>
        </label>

        {review.Evidence && (
          <div
            style={{
              display: "flex",
              alignSelf: "end",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label className="text-xs">
              <b>{localize.related_evidence}:</b>
            </label>

            <div className="mx-2">
              <label className="text-xs">
                {`${review.Evidence.Name} (${getEvidenceType(
                  review.Evidence.EvidenceType,
                )})`}
              </label>
            </div>

            <ActionButtons
              hideDeleteButton
              hideEditButton={!showEditNote}
              onClickForEditButton={
                showEditNote
                  ? () => {
                      showEditNote(review);
                    }
                  : undefined
              }
              buttons={[
                {
                  name: localize.view,
                  icon: (
                    <Visibility style={{ width: "16px", height: "16px" }} />
                  ),
                  action: () => {
                    window.open(
                      `${window.location.href}/evidence/${review.Evidence.Id}/${review.Evidence.EvidenceType}`,
                      "_blank",
                    );
                  },
                },
              ]}
            />
          </div>
        )}
      </div>

      <Divider />

      <div className="mt-2 mb-2">
        <label
          className="text-xs"
          style={{ whiteSpace: "pre-wrap" }}
        >{`${review.Observation}`}</label>
      </div>

      <Divider />
      <div
        className="mt-2"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <label className="text-xs">
          <b>{`${review.CreatedBy}`}</b>
        </label>
        {review.CreationDate && (
          <label className="text-xs">
            <b>{`${new Date(review.CreationDate).toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}`}</b>
          </label>
        )}
      </div>
    </Card>
  );
}
